"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.returnEventFunction = exports.setReceivedPath = exports.setReceivedValue = exports.setReceivedLabel = exports.setReceivedMessage = exports.setLabel = exports.setAction = exports.setCategory = exports.setEvent = exports.setFixedPipedObj = exports.setParamObj = void 0;

var setParamObj = function setParamObj(paramObj) {
  return _objectSpread({}, paramObj);
};

exports.setParamObj = setParamObj;

var setFixedPipedObj = function setFixedPipedObj(obj) {
  return function (pipedObj) {
    return _objectSpread(_objectSpread({}, pipedObj), obj);
  };
};

exports.setFixedPipedObj = setFixedPipedObj;

var setEvent = function setEvent(event) {
  return setFixedPipedObj({
    event: event
  });
};

exports.setEvent = setEvent;

var setCategory = function setCategory(category) {
  return setFixedPipedObj({
    category: category
  });
};

exports.setCategory = setCategory;

var setAction = function setAction(action) {
  return setFixedPipedObj({
    action: action
  });
};

exports.setAction = setAction;

var setLabel = function setLabel(label) {
  return setFixedPipedObj({
    label: label
  });
};

exports.setLabel = setLabel;

var setReceivedMessage = function setReceivedMessage(message) {
  return setParamObj({
    message: message
  });
};

exports.setReceivedMessage = setReceivedMessage;

var setReceivedLabel = function setReceivedLabel(label) {
  return setParamObj({
    label: label
  });
};

exports.setReceivedLabel = setReceivedLabel;

var setReceivedValue = function setReceivedValue(value) {
  return setParamObj({
    value: value
  });
};

exports.setReceivedValue = setReceivedValue;

var setReceivedPath = function setReceivedPath(path) {
  return setParamObj({
    path: path
  });
};

exports.setReceivedPath = setReceivedPath;

var returnEventFunction = function returnEventFunction(fn) {
  return function () {
    return function (param) {
      return fn(param);
    };
  };
};

exports.returnEventFunction = returnEventFunction;